import { HttpClient } from '../HttpClient';
import { ClientResponse } from '../../types/getClientInterface';

/**
 * Get Client's Current Details
 */
export const GetClient = async (): Promise<ClientResponse> => {
  try {
    const { data } = await HttpClient.get('api/clients/current');
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
